export default "__VITE_ASSET__hvpiWVOf__"